/*
 Utility function to fetch required data for component to render in server side.
 This was inspired from https://github.com/caljrimmer/isomorphic-redux-app/blob/73e6e7d43ccd41e2eb557a70be79cebc494ee54b/src/common/api/fetchComponentDataBeforeRender.js
 */
import routes from "../../config/route";
import matchRoutes from "./matchRoutes";
import {
  getAboutUsContent,
  getAboutCorporateContent,
  getMessageContent,
  getCorporateGovernanceContent,
  getAboutUsFinancialInfo,
  getCorporateGovernancePost,
  postCsr,
  getAboutUsMediaCenterNew,
  getAboutUsMediaCenterVideo,
} from "../../app/components/landing/AboutUs/actions";

import {getGlossaryAlphabet} from "../../app/components/landing/Glossary/actions"; 

import {
  learnersCornerList,
  learnCornerLevels,
  getIapDocuments,
  investorawareness,
  getkeyKnowInfo,
  cornerVideoApi,
  cornerPodcastApi,
  toolsCalculate,
  getCalculatorMetaData,
  getTheReadingRoom,
  getBookReview,
  PoetryLounge,
  getMfBytesMetaData,
  cornerSectionOverview,
} from "../../app/components/landing/LearnersCorner/actions";

import {
  getAllFundProducts,
  getEtf,
  productIndexList,
  getNfoList,
  getSingleFundDetails,
} from "../../app/components/landing/ProductSolutions/actions";

import {
  getGoldCash
} from "../../app/components/landing/Product/CashComponent/actions";

import { getContactUsContent, getChiefInformation } from "../../app/components/landing/ContactUs/actions";

import {
  investorLandingPage,
  getFactsheet,
  fundLiteratureDocument,
  getFundLitrature,
  getInvestorFaq,
  getadditionalFundInfo,
  getSchemeAccountFiltersnew,
  investorFormList,
  noticesAgendaList,
  additionalInfo,
  ouronlineservices,
  getInvestorMarket,
  fundDocumentFilters,
  getAgendaMonth,
  getWeeklyPortfolioDetails
} from "../../app/components/landing/InvestorServices/actions";

import {
  getstatutoryList,
  getnewStatutoryContent,
  getEmployeeCompensationsaturity,
  getStatutoryFilterNewPortfolio,
  getPublicCautiondata,
  getRemunerationContentNew,
  getTerNewCommon,
  getTerReportContent,
  getTerReportMonthFilter,
  getTerNoticeContent,
} from "../../app/components/landing/StatutoryDisclosure/actions";

import { unClaimedMeta } from "../../app/components/landing/StatutoryDisclosure/UnclaimedDividendRedemptionNew/action";

import {
  getDistributorCornerNew,
  getDistributorCornerMFD,
  getDistriutorCornerOnboardDigitally,
  getDistriutorCornerOnboardLogin,
  getDistributorCornerFormsDisclosure,
  getDistributorCornerFaqs,
  getDistributerSEBI,
  getHandBook
} from "../../app/components/landing/DistributorCorner/actions";

import { getHome,
  getHomePageDataStatic,
  getTrendingFundData, allAnnouncementMeta} from "../../app/components/landing/HomepageNew/action";
import { getNavDividendContent } from "../../app/components/landing/NavDividend/actions";
import { getWhatsAppService } from "../../app/components/landing/WhatsappJourney/action";
import { faqGenerator } from "../common";
import { getMenu, promotionalHeader } from "../../app/actions";
import { getCareerContent } from "../../app/components/landing/Careers/actions";
import { allSectionsMeta } from "../../app/components/landing/AccountStatement/actions";
import {BeginnerDetail} from "../../app/components/landing/BeginnerInformation/actions";
import {IntermediateDetail} from "../../app/components/landing/IntermediateInformation/actions";
import {AdvanceDetail} from "../../app/components/landing/AadvancedInformation/actions";
import {getSipBannerContent} from "../../app/components/landing/Learn/Sip/action";
import {goalVideoPodcastBlogs} from "../../app/components/landing/GoalMarketing/actions";
import {getSitemapContent} from "../../app/components/landing/Sitemap/actions";
import {getStaticPageContent} from "../../app/components/landing/PrivacyPolicy/actions";
import {
  knowledgestackListing,
  // getMDMsgData,
  mdArticleList,
  mdVideosList,
  mdInterviewArticleList,
  // mdInterviewVideosList,
  getMarketReviewList,
  mfYearBook,
  getCreditPolicy,
  getTuesdayTalkingPoints,
  getChartScope,
  getHdfcMfInsights,
  getWeekendBytes,
  getMusingsList,
  mediaHouseVideosList,
  getKnowledgeStackPodcast,
  getWebinarList,
  getBehaviouralBlogs,
} from "../../app/components/landing/KnowledgeStack/actions";
import {getIAPRegistrationData, quizSaheliMeta} from "../../app/components/landing/IAPWomen/actions";
import { getjanNivesh } from "../../app/components/landing/JanNivesh/action";

const sequence = (items, consumer) => {
  const results = [];
  const runner = () => {
    const item = items.shift();
    if (item) {
      return consumer(item)
        .then((result) => {
          results.push(result);
        })
        .then(runner);
    }
    return Promise.resolve(results);
  };
  return runner();
};

export default (location, store, res) => {
  var loadActions = [];
  var loadParams = "";
  var faqKey = "";
  var ignoreFAQTitle = false;
  var videoObjMapper = null;
  if (location.uri) {
    // console.log("uri in perload store", location.uri);

    switch (location.uri) {
      // For About Us Pages
      case "/":
        loadActions = [getHomePageDataStatic,getHome,getTrendingFundData];
        loadParams = "home";
        break;
      case "/important-announcement":
        loadActions = [allAnnouncementMeta];
        loadParams = "important-announcement";
        break;
      // New AboutUs
      case "/about-us":
        loadActions = [getAboutUsContent];
        loadParams = "aboutus";
        break;
      case "/about-us/corporate-profile/hdfc-mf-at-a-glance":
        loadActions = [getAboutCorporateContent];
        loadParams = "hdfc-mf-at-a-glance";
        break;

      case "/about-us/corporate-profile/what-we-stand-for":
        loadActions = [getAboutCorporateContent];
        loadParams = "what-we-stand-for";
        break;

      case "/about-us/corporate-profile/esg":
        loadActions = [getAboutCorporateContent];
        loadParams = "esg";
        break;

      case "/about-us/corporate-profile/csr":
        loadActions = [postCsr];
        loadParams = "csr";
        break;

      case "/about-us/corporate-profile/what-sets-us-apart":
        loadActions = [getAboutCorporateContent];
        loadParams = "what-sets-us-apart";
        break;

      case "/about-us/financial-information/annual-reports":
        loadActions = [getAboutUsFinancialInfo];
        loadParams = "annual-reports";
        break;

      case "/about-us/financial-information/financial-results":
        loadActions = [getAboutUsFinancialInfo];
        loadParams = "financial-results";
        break;

      case "/about-us/financial-information/shareholder-presentation":
        loadActions = [getAboutUsFinancialInfo];
        loadParams = "shareholder-presentation";
        break;

      case "/about-us/corporate-governance/code-policy":
        loadActions = [getCorporateGovernancePost];
        loadParams = "code-policy";
        break;

      case "/about-us/corporate-governance/disclosures":
        loadActions = [getCorporateGovernancePost];
        loadParams = "disclosures";
        break;

      case "/about-us/corporate-governance/dividend":
        loadActions = [getCorporateGovernanceContent];
        loadParams = "dividend";
        break;

      case "/about-us/corporate-governance/board-committee":
        loadActions = [getCorporateGovernanceContent];
        loadParams = "board-committee";
        break;
      case "/about-us/our-board-and-trustees/board-of-directors":
        loadActions = [getMessageContent];
        loadParams = "board-of-directors";
        break;
      case "/about-us/our-board-and-trustees/trustees":
        loadActions = [getMessageContent];
        loadParams = "trustees";
        break;
      case "/about-us/media-center":
        loadActions = [getAboutUsMediaCenterNew , getAboutUsMediaCenterVideo];
        loadParams = "media-center";
        break;
      case "/about-us/media-center/press-releases":
        loadActions = [getAboutUsMediaCenterNew , getAboutUsMediaCenterVideo];
        loadParams = "press-releases";
        break;
      case "/about-us/media-center/media-interactions":
        loadActions = [getAboutUsMediaCenterNew , getAboutUsMediaCenterVideo];
        loadParams = "media-interactions";
        break;

      // New AboutUs End

      // New Start Learn Corner

      case "/learners-corner":
        loadActions = [learnersCornerList];
        loadParams = "learners-corner";
        break;

      case "/learners-corner/beginner":
        loadActions = [learnCornerLevels];
        loadParams = "beginner";
        break;

      case location.uri.match(/beginner/)?.input:
        loadActions = [BeginnerDetail];
        faqKey = "faqs";
        loadParams = "beginner";
        break;  

      case "/learners-corner/intermediate":
        loadActions = [learnCornerLevels];
        loadParams = "intermediate";
        break;

      case location.uri.match(/intermediate/)?.input:
        loadActions = [IntermediateDetail];
        faqKey = "faqs";
        loadParams = "intermediate";
        break;  

      case "/learners-corner/advanced":
        loadActions = [learnCornerLevels];
        loadParams = "advanced";
        break;

      case location.uri.match(/advanced/)?.input:
        loadActions = [AdvanceDetail];
        faqKey = "faqs";
        loadParams = "advanced";
        break;    

      case "/learners-corner/investor-awareness/iap-downloads":
        loadActions = [getIapDocuments];
        loadParams = "iap-downloads";
        break;

      case "/learners-corner/investor-awareness/investor-awareness-programmes":
        loadActions = [investorawareness];
        faqKey = "iapFaqs";
        loadParams = "investor-awareness-programmes";
        break;

      case "/learners-corner/investor-awareness/kyc-redressal-complaints":
        loadActions = [getkeyKnowInfo];
        loadParams = "kyc-redressal-complaints";
        break;
      case "/learners-corner/investor-awareness/mf-bytes-app":
        loadActions = [getMfBytesMetaData];
        loadParams = "mf-bytes-app";
        break;
      case "/learners-corner/videos":
        loadActions = [cornerVideoApi];
        loadParams = "videos";
        break;

      case "/learners-corner/podcast":
        loadActions = [cornerPodcastApi];
        loadParams = "podcast";
        break;

      case "/learners-corner/calculator":
        loadActions = [toolsCalculate , cornerSectionOverview];
        loadParams = "calculator";
        break;
      case "/learners-corner/impact-of-inflation":
        loadActions = [getCalculatorMetaData];
        loadParams = "impact-of-inflation";
        break;
      case "/learners-corner/sip-calculator":
        loadActions = [getCalculatorMetaData];
        loadParams = "sip-calculator";
        break;
      case "/learners-corner/present-value":
        loadActions = [getCalculatorMetaData];
        loadParams = "present-value";
        break;
      case "/learners-corner/goal-sip":
        loadActions = [getCalculatorMetaData];
        loadParams = "goal-sip";
        break;
      case "/learners-corner/top-up-sip":
        loadActions = [getCalculatorMetaData];
        loadParams = "top-up-sip";
        break;
      case "/learners-corner/stp-calculator":
        loadActions = [getCalculatorMetaData];
        loadParams = "stp-calculator";
        break;
      case "/learners-corner/swap-calculator":
        loadActions = [getCalculatorMetaData];
        loadParams = "swap-calculator";
        break;
      case "/learners-corner/retirement-calculator":
        loadActions = [getCalculatorMetaData];
        loadParams = "retirement-calculator";
        break;
      case "/learners-corner/cost-of-child-education":
        loadActions = [getCalculatorMetaData];
        loadParams = "cost-of-child-education";
        break;
      case "/learners-corner/the-reading-room":
        loadActions = [getTheReadingRoom, cornerSectionOverview];
        loadParams = "the-reading-room";
        break;
      case "/learners-corner/the-reading-room/book-review-zone":
        loadActions = [getBookReview, cornerSectionOverview];
        loadParams = "book-review-zone";
        break;
      case "/learners-corner/the-reading-room/poetry-lounge":
        loadActions = [PoetryLounge, cornerSectionOverview];
        loadParams = "poetry-lounge";
        break;
      // End Start Learn Corner
      //Sip saheli start
      case "/sipsaheli/registration":
        loadActions = [getIAPRegistrationData];
        loadParams = "sipsaheli";
        break;
      case "/quiz-sipsaheli":
        loadActions = [quizSaheliMeta];
        loadParams = "quiz-sipsaheli";
        break;   
      case "/quiz-sipsaheli/events":
        loadActions = [quizSaheliMeta];
        loadParams = "quiz-sipsaheli-events";
        break; 
      case "/quiz-sipsaheli/hi":
        loadActions = [quizSaheliMeta];
        loadParams = "quiz-sipsaheli-hindi";
        break;  
      //Sip saheli end
      // product solution start
      case "/product-solutions":
        loadActions = [getAllFundProducts];
        loadParams = "product-solutions";
        break;

      case "/product-solutions/wealth-creation":
        loadActions = [getAllFundProducts];
        loadParams = "wealth-creation";
        break;
      case "/product-solutions/income-solutions":
        loadActions = [getAllFundProducts];
        loadParams = "income-solutions";
        break;
      case "/product-solutions/tax-savings":
        loadActions = [getAllFundProducts];
        loadParams = "tax-savings";
        break;
      case "/product-solutions/retirement-planning":
        loadActions = [getAllFundProducts];
        loadParams = "retirement-planning";
        break;
      case "/product-solutions/children-fund":
        loadActions = [getAllFundProducts];
        loadParams = "children-fund";
        break;
      case "/product-solutions/retirement-fund":
        loadActions = [getAllFundProducts];
        loadParams = "retirement-fund";
        break;
      case "/product-solutions/diversified-equity":
        loadActions = [getAllFundProducts];
        loadParams = "diversified-equity";
        break;
      case "/product-solutions/index":
        loadActions = [productIndexList];
        loadParams = "index";
        break;
      case "/product-solutions/etf":
        loadActions = [getEtf];
        loadParams = "etf";
        break;
      case "/product-solutions/hybrid":
        loadActions = [getAllFundProducts];
        loadParams = "hybrid";
        break;
      case "/product-solutions/gold-etf/fof":
        loadActions = [getAllFundProducts];
        loadParams = "gold-etf/fof";
        break;
      case "/product-solutions/theme-based-debt":
        loadActions = [getAllFundProducts];
        loadParams = "theme-based-debt";
        break;
      case "/product-solutions/equity-linked-savings-scheme-elss":
        loadActions = [getAllFundProducts];
        loadParams = "equity-linked-savings-scheme-elss";
        break;
      case "/product-solutions/thematic-equity":
        loadActions = [getAllFundProducts];
        loadParams = "thematic-equity";
        break;
      case "/product-solutions/solution-oriented":
        loadActions = [getAllFundProducts];
        loadParams = "solution-oriented";
        break;
      case "/product-solutions/duration-based-debt":
        loadActions = [getAllFundProducts];
        loadParams = "duration-based-debt";
        break;
      case "/product-solutions/fund-of-funds":
        loadActions = [getAllFundProducts];
        loadParams = "fund-of-funds";
        break;
      case "/product-solutions/thematic/sectoral-equity":
        loadActions = [getAllFundProducts];
        loadParams = "thematic/sectoral-equity";
        break;
      case "/product-solutions/nfo":
        loadActions = [getNfoList];
        loadParams = "nfo";
        break;
      
      case "/product-solutions/creation-component/gold-cash-component":
        loadActions = [getGoldCash];
        loadParams = "gold-cash-component";
        break;

      case "/product-solutions/creation-component/silver-cash-component":
        loadActions = [getGoldCash];
        loadParams = "silver-cash-component";
        break;
      // product solution end

      case "/nav-and-idcw/latest-navs-and-idcw":
        loadActions = [getNavDividendContent];
        loadParams = "nav-idcw";
        break;

      // Start Investor Services
      case "/investor-services":
        loadActions = [investorLandingPage];
        loadParams = "investor-services";
        break;
      case "/investor-services/factsheets":
        loadActions = [getFactsheet];
        loadParams = "factsheets";
        break;
      case "/investor-services/fund-documents/kim":
        loadActions = [fundLiteratureDocument, fundDocumentFilters];
        loadParams = "kim";
        break;
      case "/investor-services/fund-documents/sid":
        loadActions = [fundLiteratureDocument, fundDocumentFilters];
        loadParams = "sid";
        break;
      case "/investor-services/fund-documents/scheme-summary":
        loadActions = [fundLiteratureDocument, fundDocumentFilters];
        loadParams = "scheme-summary";
        break;
      case "/investor-services/fund-literature/leaflets":
        loadActions = [getFundLitrature, fundDocumentFilters];
        loadParams = "leaflets";
        break;
      case "/investor-services/fund-literature/presentation":
        loadActions = [getFundLitrature, fundDocumentFilters];
        loadParams = "presentation";
        break;
      case "/investor-services/additional-fund-info":
        loadActions = [getadditionalFundInfo];
        loadParams = "additional-fund-info";
        break;
      case "/investor-services/scheme-collection":
        loadActions = [getSchemeAccountFiltersnew];
        loadParams = "scheme-collection";
        break;
      case "/investor-services/form-disclosures/forms":
        loadActions = [investorFormList];
        loadParams = "investor-form";
        break;
      case "/investor-services/form-disclosures/addenda-notices":
        loadActions = [noticesAgendaList, getAgendaMonth];
        loadParams = "addenda-notices";
        break;
      case "/investor-services/form-disclosures/additional-info":
        loadActions = [additionalInfo];
        loadParams = "additional-info";
        break;
      case "/investor-services/our-online-services/mf-online-investors":
        loadActions = [ouronlineservices];
        loadParams = "mf-online-investors";
        break;
      case "/investor-services/our-online-services/quick-invest":
        loadActions = [ouronlineservices];
        loadParams = "quick-invest";
        break;
      case "/investor-services/market-update/documents":
        loadActions = [getInvestorMarket];
        loadParams = "market-documents";
        break;
      case "/investor-services/market-update/videos":
        loadActions = [getInvestorMarket];
        loadParams = "market-videos";
        break;
      case "/investor-services/investor-faq/online":
        loadActions = [getInvestorFaq];
        loadParams = "online";
        faqKey = "data";
        break;
      case "/investor-services/investor-faq/general":
        loadActions = [getInvestorFaq];
        loadParams = "general";
        faqKey = "investorFaqs";
        // ignoreFAQTitle = true;
        break;
      case "/investor-services/weekly-debt-and-portfolio-details":
        loadActions = [getWeeklyPortfolioDetails];
        loadParams = "weekly-debt-and-portfolio-details";
        break;

      // End Investor Services

      // Distributor corner start
      case "/distributor-corner":
        loadActions = [getDistributorCornerNew];
        loadParams = "distributor-corner";
        break;
      case "/distributor-corner/being-a-mfd/why-become-mfd":
        loadActions = [getDistributorCornerMFD];
        loadParams = "why-become-mfd";
        break;
      case "/distributor-corner/being-a-mfd/get-started":
        loadActions = [getDistributorCornerMFD];
        loadParams = "get-started";
        break;
      case "/distributor-corner/being-a-mfd/become-an-distributor":
        loadActions = [getDistributorCornerMFD];
        loadParams = "become-an-distributor";
        break;
      case "/distributor-corner/onboard-digitally/login":
        loadActions = [getDistriutorCornerOnboardLogin];
        loadParams = "login";
        break;
      case "/distributor-corner/onboard-digitally/why-online":
        loadActions = [getDistriutorCornerOnboardDigitally];
        loadParams = "why-online";
        break;
      case "/distributor-corner/onboard-digitally/connekt":
        loadActions = [getDistriutorCornerOnboardDigitally];
        loadParams = "connekt";
        break;
      case "/distributor-corner/forms-disclosure/forms":
        loadActions = [getDistributorCornerFormsDisclosure];
        loadParams = "distributor-forms";
        break;
      case "/distributor-corner/forms-disclosure/disclosures":
        loadActions = [getDistributorCornerFormsDisclosure];
        loadParams = "distributor-disclosures";
        break;
      case "/distributor-corner/faqs":
        loadActions = [getDistributorCornerFaqs];
        loadParams = "faqs";
        faqKey = "distributorFaqs";
        break;
      case "/distributor-corner/sebi-code-of-conduct":
        loadActions = [getDistributerSEBI];
        loadParams = "sebi-code-of-conduct";
        break;
      case "/distributor-corner/handbook":
        loadActions = [getHandBook];
        loadParams = "distributor-handbook";
        break;
      // Distributor corner end
      // knowledge Stack start
      case "/knowledge-stack":
        loadActions = [knowledgestackListing];
        loadParams = "knowledge-stack";
        break;
      // case "/knowledge-stack/md-ceo-desk":
      //   loadActions = [getMDMsgData];
      //   loadParams = "md-ceo-desk";
      //   break;
      case "/knowledge-stack/md-ceo-desk/articles":
        loadActions = [mdArticleList];
        loadParams = "md-ceo-desk-articles";
        break;
      case "/knowledge-stack/md-ceo-desk/videos":
        loadActions = [mdVideosList];
        loadParams = "md-ceo-desk-videos";
        break;
      case "/knowledge-stack/md-ceo-desk/interviews":
        loadActions = [mdInterviewArticleList];
        loadParams = "interview-articles";
        break;
      // case "/knowledge-stack/md-ceo-desk/media/video":
      //   loadActions = [mdInterviewVideosList];
      //   loadParams = "interview-videos";
      //   break;
      case "/knowledge-stack/macro-insights/market-review":
        loadActions = [getMarketReviewList];
        loadParams = "market-review";
        break;
      case "/knowledge-stack/macro-insights/hdfc-mf-yearbook":
        loadActions = [mfYearBook];
        loadParams = "hdfc-mf-yearbook";
        break;
      case "/knowledge-stack/macro-insights/monetary-policy-review":
        loadActions = [getCreditPolicy];
        loadParams = "monetary-policy-review";
        break;
      case "/knowledge-stack/deep-dives/tuesdays-talking-points":
        loadActions = [getTuesdayTalkingPoints];
        loadParams = "tuesdays-talking-points";
        break;
      case "/knowledge-stack/deep-dives/chartscope":
        loadActions = [getChartScope];
        loadParams = "chartscope";
        break;
      case "/knowledge-stack/deep-dives/hdfc-mf-insights":
        loadActions = [getHdfcMfInsights];
        loadParams = "hdfc-mf-insights";
        break;  
      case "/knowledge-stack/mf-vault/weekend-bytes":
        loadActions = [getWeekendBytes];
        loadParams = "weekend-bytes";
        break;
      case "/knowledge-stack/mf-vault/musings":
        loadActions = [getMusingsList];
        loadParams = "musings";
        break;
      case "/knowledge-stack/interactive-media/videos":
        loadActions = [mediaHouseVideosList];
        loadParams = "videos";
        break;
      case "/knowledge-stack/interactive-media/podcasts":
        loadActions = [getKnowledgeStackPodcast];
        loadParams = "podcasts";
        break;
      case "/knowledge-stack/interactive-media/webinar":
        loadActions = [getWebinarList];
        loadParams = "webinar";
        break;
      case "/knowledge-stack/behavioural-blogs":
        loadActions = [getBehaviouralBlogs];
        loadParams = "behavioural-blogs";
        break;
      // knowledge Stack end

      // Contact Us pages
      case "/contact-us/get-in-touch":
        loadActions = [getContactUsContent];
        loadParams = "get-in-touch";
        break;
      case "/contact-us/visit-us":
        loadActions = [getContactUsContent];
        loadParams = "visit-us";
        break;
      case "/contact-us/investor-relationship-officer":
        loadActions = [getContactUsContent];
        loadParams = "investor-relationship-officer";
        break;
      case "/contact-us/stakeholders-information-and-helpdesk":
        loadActions = [getContactUsContent];
        loadParams = "stakeholders-information-and-helpdesk";
        break;
      case "/contact-us/chief-information-security-officer":
        loadActions = [getChiefInformation];
        loadParams = "chief-information-security-officer";
        break;
      // Contact Us pages end
      // statutory-disclosure starts
      case "/statutory-disclosure":
        loadActions = [getstatutoryList];
        loadParams = "statutory-disclosure";
        break;
      case "/statutory-disclosure/abridged":
        loadActions = [getnewStatutoryContent];
        loadParams = "abridged";
        break;
      case "/statutory-disclosure/riskometers":
        loadActions = [getnewStatutoryContent];
        loadParams = "riskometers";
        break;
      case "/statutory-disclosure/annual-reports":
        loadActions = [getnewStatutoryContent];
        loadParams = "disclosure-annual-reports";
        break;
      case "/statutory-disclosure/aum":
        loadActions = [getnewStatutoryContent];
        loadParams = "aum";
        break;
      case "/statutory-disclosure/average-portfolio":
        loadActions = [getnewStatutoryContent];
        loadParams = "average-portfolio";
        break;
      case "/statutory-disclosure/details-deviations-valuation-price-provided-valuation-agencies":
        loadActions = [getnewStatutoryContent];
        loadParams =
          "details-deviations-valuation-price-provided-valuation-agencies";
        break;
      case "/statutory-disclosure/disclosure-of-designated-employees":
        loadActions = [getEmployeeCompensationsaturity];
        loadParams = "disclosure-of-designated-employees";
        break;
      case "/statutory-disclosure/trade":
        loadActions = [getnewStatutoryContent];
        loadParams = "trade";
        break;
      case "/statutory-disclosure/commission":
        loadActions = [getnewStatutoryContent];
        loadParams = "commission";
        break;
      case "/statutory-disclosure/scheme-financials":
        loadActions = [getnewStatutoryContent];
        loadParams = "scheme-financials";
        break;
      case "/statutory-disclosure/data-on-investor-complaints":
        loadActions = [getnewStatutoryContent];
        loadParams = "data-on-investor-complaints";
        break;
      case "/statutory-disclosure/investor-complaints-pms":
        loadActions = [getnewStatutoryContent];
        loadParams = "investor-complaints-pms";
        break;  
      case "/statutory-disclosure/letter-unitholder":
        loadActions = [getnewStatutoryContent];
        loadParams = "letter-unitholder";
        break;
      case "/statutory-disclosure/mandatory-investment-amc":
        loadActions = [getnewStatutoryContent];
        loadParams = "mandatory-investment-amc";
        break;
      case "/statutory-disclosure/portfolio/monthly-portfolio":
        loadActions = [getStatutoryFilterNewPortfolio];
        loadParams = "monthly-portfolio";
        break;
      case "/statutory-disclosure/portfolio/fortnightly-portfolio":
        loadActions = [getStatutoryFilterNewPortfolio];
        loadParams = "fortnightly-portfolio";
        break;
      case "/statutory-disclosure/public-caution-notice":
        loadActions = [getPublicCautiondata];
        loadParams = "public-caution-notice";
        break;
      case "/statutory-disclosure/remuneration":
        loadActions = [getRemunerationContentNew];
        loadParams = "remuneration";
        break;
      case "/statutory-disclosure/scheme-performance":
        loadActions = [getnewStatutoryContent];
        loadParams = "scheme-performance";
        break;
      case "/statutory-disclosure/complaints":
        loadActions = [getnewStatutoryContent];
        loadParams = "complaints";
        break;
      case "/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/reports":
        loadActions = [getTerNewCommon, getTerReportContent, getTerReportMonthFilter];
        loadParams = "expense-reports";
        break;
      case "/statutory-disclosure/total-expense-ratio-of-mutual-fund-schemes/notices":
        loadActions = [getTerNewCommon, getTerNoticeContent];
        loadParams = "expense-notices";
        break;
      case "/statutory-disclosure/tracking-error":
        loadActions = [getnewStatutoryContent];
        loadParams = "tracking-error";
        break;
      case "/statutory-disclosure/voting":
        loadActions = [getnewStatutoryContent];
        loadParams = "voting";
        break;
      case "/statutory-disclosure/stewardship-report":
        loadActions = [getnewStatutoryContent];
        loadParams = "stewardship-report";
        break;
      case "/statutory-disclosure/offer-document-disclosures":
        loadActions = [getnewStatutoryContent];
        loadParams = "offer-document-disclosures";
        break;
      case "/statutory-disclosure/statutory-disclosure-hdfc-mid-cap-opportunities-fund-and-hdfc-small-cap-fund":
        loadActions = [getnewStatutoryContent];
        loadParams = "statutory-disclosure-hdfc-mid-cap-opportunities-fund-and-hdfc-small-cap-fund";
        break;
      case "/statutory-disclosure/disclosure-on-distributor-related-expenses":
        loadActions = [getnewStatutoryContent];
        loadParams = "disclosure-on-distributor-related-expenses";
        break;
      case "/statutory-disclosure/market-makers-authorized-participants":
        loadActions = [getnewStatutoryContent];
        loadParams = "market-makers-authorized-participants";
        break;  
      case "/statutory-disclosure/disclosure-of-issuerwise-groupwise-sectorwise-exposure-for-etf-index-funds":
        loadActions = [getnewStatutoryContent];
        loadParams = "disclosure-of-issuerwise-groupwise-sectorwise-exposure-for-etf-index-funds";
        break;
      case "/statutory-disclosure/information-ratio-disclosure-for-equity-mutual-funds":
        loadActions = [getnewStatutoryContent];
        loadParams = "information-ratio-disclosure-for-equity-mutual-funds";
        break;
      case "/statutory-disclosure/report-misselling":
        loadActions = [getnewStatutoryContent];
        loadParams = "report-misselling";
        break;
      case "/statutory-disclosure/unclaimed-dividend-and-redemption":
        loadActions = [unClaimedMeta];
        loadParams = "unclaimed-dividend-and-redemption";
        break;
      // statutory-disclosure ends

      case "/whats-app-service":
        loadActions = [getWhatsAppService];
        loadParams = "whatsapp";
        faqKey = "faqs";
        break;
      
      case "/account-statement":
        loadActions = [allSectionsMeta];
        loadParams = "account-statement";
        break;
        
      case "/careers":
        loadActions = [getCareerContent];
        loadParams = "careers";
        break;

      case "/learn/sip":
        loadActions = [getSipBannerContent];
        loadParams = "sip-campaign";
        break;

      case "/goal":
        loadActions = [goalVideoPodcastBlogs];
        loadParams = "goal-campaign";
        break;

      case "/sitemap":
        loadActions = [getSitemapContent];
        loadParams = "sitemap";
        break;
      
      case "/disclaimer":
        loadActions = [getStaticPageContent];
        loadParams = "disclaimer";
        break;

      case "/privacy-policy":
        loadActions = [getStaticPageContent];
        loadParams = "privacy-policy";
        break;  
      case "/glossary":
        loadActions = [getGlossaryAlphabet];
        loadParams = "glossary";
        break;
      case "/product-solutions/overview/:fundtype/:plantype":
        loadActions = [getSingleFundDetails];
        loadParams = "product-fundtype";
        break;
      case "/chhotisip":
        loadActions = [getjanNivesh];
        loadParams = "chhotisip";
        break;
      default:
        break;
    }
  }

  loadActions.push(getMenu, promotionalHeader);
  
  const matchedRoutes = matchRoutes(routes, location.uri);
  // console.log("matchedRoutes===",JSON.stringify(matchedRoutes));
  if (matchedRoutes.length == 0) {
    return Promise.resolve(true);
  }
  if(matchedRoutes && matchedRoutes[0] && matchedRoutes[0].route && matchedRoutes[0].route.path == "*"){
    res.status(404);
  }
  // console.log("matchedRoutes", JSON.stringify(matchedRoutes));

  const paramsWithActions = matchedRoutes.reduce(
    (paramsList, { route, match }) =>
      route.loadData && route.loadData.length > 0
        ? paramsList.concat({
            actions: route.loadData,
            params: match.params,
            url: match.url,
          })
        : paramsList,
    []
  );
  // console.log("Before NEED==============", paramsWithActions);

  const actionList = paramsWithActions.reduce(
    (actionList, { actions, params, url }) =>
      actions.length > 0
        ? actionList.concat(actions.map((action) => ({ action, params, url })))
        : actionList,
    []
  );
  // needs = flatten(needs);
  //console.log("After NEED==============", actionList);

  const loadNewActions = loadActions.map((newActionToLoad) => ({
    action: newActionToLoad,
    params: { type: loadParams, faqKey, ignoreFAQTitle },
    url: location.uri,
  }));
  // console.log("Load new added actions too ==============", loadNewActions);

  const combinedActions = actionList.concat(loadNewActions);
  // console.log("Combined Actions ==============", combinedActions);

  const promisesObj = combinedActions.reduce(
    (promisesObj, actionObj) => {
      typeof actionObj.action == "object"
        ? promisesObj.sequential.push(actionObj)
        : Object.keys(actionObj.params).length !== 0
        ? promisesObj.parallel.push(actionObj)
        : [];
      return promisesObj;
    },
    { sequential: [], parallel: [] }
  );
  const actionPara = {
    queryString: location.uri,
    params: {},
    store: {},
    response: res,
  };
  const sortedSequentialPromises = promisesObj.sequential.sort(
    (a, b) => a.action.priority - b.action.priority
  );
  //console.log("sortedSequentialPromises############",JSON.stringify(sortedSequentialPromises));

  const parallelPromisesArray = promisesObj.parallel.map((actionObj) => {
    return store
      .dispatch(
        actionObj.action({
          ...actionPara,
          store: store.getState(),
          params: actionObj.params,
          url: actionObj.url,
        })
      )
      .then((data) => {
        data &&
          data.data &&
          data.data.meta &&
          store.dispatch({
            type: "ADD_META_DATA",
            data: {
              ...data.data.meta,
              ...(actionObj.params.faqKey && {
                faqs: faqGenerator(
                  data.data[actionObj.params.faqKey],
                  actionObj.params.ignoreFAQTitle
                ),
              }),
              ...(videoObjMapper && { videoObj: videoObjMapper(data) }),
            },
          });
      });
  });
  const sequentialPromises = sequence(sortedSequentialPromises, (actionObj) =>
    store.dispatch(
      actionObj.action
        .actionName({
          ...actionPara,
          store: store.getState(),
          params: actionObj.params,
        })
        .then((data) => {
          data &&
            data.data &&
            data.data.meta &&
            store.dispatch({
              type: "ADD_META_DATA",
              data: {
                ...data.data.meta,
                ...(actionObj.params.faqKey && {
                  faqs: faqGenerator(
                    data.data[actionObj.params.faqKey],
                    actionObj.params.ignoreFAQTitle
                  ),
                }),
                ...(videoObjMapper && { videoObj: videoObjMapper(data) }),
              },
            });
        })
    )
  );
  return Promise.all([...parallelPromisesArray, sequentialPromises]);
  // return sequence(actionList,actionObj => store.dispatch(actionObj.action({...actionPara,store:store.getState(),params:actionObj.params})));
};
